import { MousePointerClick, Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/v2/button";
import EmptyState from "@/components/ui/v2/empty-state";
import { ROUTES } from "@/constants/routes";
import { usePermissionMatrix } from "@/lib/hooks/usePermissionMatrix";

export function SegmentDetailEmpty() {
  const { t } = useTranslation();
  const { canCreate } = usePermissionMatrix();

  const allowed = canCreate("segments");

  const description = allowed
    ? t("segments.selectSegmentDescription", "Pick a segment from the list to view its details, or create a new one.")
    : t("segments.selectSegmentDescriptionReadonly", "Pick a segment from the list to view its details.");

  return (
    <div className="flex min-h-64 flex-col items-center justify-center gap-4">
      <EmptyState
        icon={MousePointerClick}
        title={t("admin.segments.selectSegment", "Select a segment")}
        description={description}
      />
      {allowed && (
        <Button variant="default" asChild>
          <Link to={ROUTES.new}>
            <Plus className="mr-1.5 size-4" />
            {t("admin.segments.createSegment", "Create Segment")}
          </Link>
        </Button>
      )}
    </div>
  );
}
